import { Counter } from '../../../Counter'
import { getRequestProfileTabChatsToggleItemLabel } from '../RequestProfileTabChats.utils'

import * as styles from './RequestProfileTabChatsSubTabs.module.css'

export function renderRequestProfileTabChatsSubTabItem(item) {
  return (
    <span className={styles.label}>
      {getRequestProfileTabChatsToggleItemLabel(item)}
      {item.unreadCount ? <Counter count={item.unreadCount} /> : null}
    </span>
  )
}
